import { fetchFormConfigs } from "../api/formConfigApi";

export type SystemRelationSourceKey = "forms";

export type SystemRelationField = {
  name: string;
  label?: string;
};

export type SystemRelationSource = {
  key: SystemRelationSourceKey;
  label: string;
  fields: SystemRelationField[];
  fetchItems: () => Promise<any[]>;
};

const SYSTEM_RELATION_SOURCES: Record<SystemRelationSourceKey, SystemRelationSource> = {
  forms: {
    key: "forms",
    label: "Forms",
    fields: [
      { name: "title", label: "Title" },
      { name: "description", label: "Description" },
      { name: "status", label: "Status" },
      { name: "publicToken", label: "Public token" },
      { name: "componentSlug", label: "Component slug" },
      { name: "uid", label: "UID" }
    ],
    fetchItems: async () => fetchFormConfigs()
  }
};

export const getSystemRelationSource = (value?: string) => {
  if (!value) return undefined;
  return SYSTEM_RELATION_SOURCES[value as SystemRelationSourceKey];
};

export const getSystemRelationSources = () =>
  Object.values(SYSTEM_RELATION_SOURCES);
